import { useCallback, useEffect, useState } from 'preact/hooks';
import { changes } from '../../subs';

interface PlayState {
  isPlaying: boolean;
  isStopped: boolean;
}

let globalPlayState: PlayState = { isPlaying: false, isStopped: true };

export function useVPAIDPlayState(): { playState: PlayState; stopVPAID: { (): void } } {
  const [playState, setPlayState] = useState<PlayState>(globalPlayState);

  const onChanges = useCallback(() => {
    if (playState !== globalPlayState) {
      setPlayState(globalPlayState);
    }
  }, [globalPlayState]);

  useEffect(() => {
    changes && changes.unsubscribe(onChanges);
    changes && changes.subscribe(onChanges);
    return () => changes && changes.unsubscribe(onChanges);
  }, [onChanges]);

  function stopVPAID() {
    if (!playState.isPlaying) return;

    const state = { isPlaying: false, isStopped: true };

    globalPlayState = state;
    setPlayState(state);
  }

  return { playState, stopVPAID };
}

changes.subscribe(({ event }) => {
  switch (event) {
    case 'pause':
      return (globalPlayState = { isPlaying: false, isStopped: false });
    case 'play':
      return (globalPlayState = { isPlaying: true, isStopped: false });
    case 'stop':
      return (globalPlayState = { isPlaying: false, isStopped: true });
  }
});
